import { format } from 'date-fns';
import { timeToTimestampFormatter } from '@helpers/timeToTimestampFormatter';

export const formatToTimezone = (selectedHour: string, selectedDate: Date) => format(timeToTimestampFormatter(String(selectedHour), selectedDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
